"use client"

import { useEffect, useState, useCallback } from "react"
import { JinCartDropdown } from "../header-classic/jin-cart-dropdown"
import { fetchCartAction } from "./cart-action"
import { onCartUpdate, onCartDelta } from "@lib/cart-event"

export default function JinCartButton() {
  const [cart, setCart] = useState<any>(null)
  // Optimistic badge count — updated immediately on delta events, reset on server refresh
  const [optimisticCount, setOptimisticCount] = useState<number | null>(null)

  const refresh = useCallback(() => {
    fetchCartAction().then((freshCart) => {
      setCart(freshCart)
      setOptimisticCount(null) // clear optimistic — real data arrived
    })
  }, [])

  useEffect(() => {
    refresh()
    const unsubUpdate = onCartUpdate(refresh)
    const unsubDelta = onCartDelta((delta) => {
      setOptimisticCount((prev) => {
        // Base off current cart items if no optimistic value yet
        const currentBase =
          prev !== null
            ? prev
            : (cart?.items?.reduce((acc: number, item: any) => acc + item.quantity, 0) ?? 0)
        return Math.max(0, currentBase + delta)
      })
    })
    return () => {
      unsubUpdate()
      unsubDelta()
    }
    // cart intentionally excluded — delta handler captures snapshot, refresh resets
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return <JinCartDropdown cart={cart} badgeCountOverride={optimisticCount ?? undefined} />
}
